import { render } from "./OverlayTooltipsButton.vue?vue&type=template&id=50685460&scoped=true"
import script from "./OverlayTooltipsButton.vue?vue&type=script&lang=js"
export * from "./OverlayTooltipsButton.vue?vue&type=script&lang=js"

import "./OverlayTooltipsButton.vue?vue&type=style&index=0&id=50685460&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50685460"]])

export default __exports__